// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"4713d216","201":"336e4ef5","291":"b3049043","392":"45b62e37","673":"089d1267","717":"13bee2b3","728":"ed1ee571"}[chunkId] + ".chunk.css";
};